import React, { useEffect } from "react";
import parse from "html-react-parser";
export const ConvertToHtmlComponent = (props) => {
    const { htmlString } = props;
    useEffect(() => { }, []);
    return React.createElement("div", null, parse(htmlString));
};
